import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import { token } from "functions/Helper";
import CreateMerchantInventories from "views/MerchantInventories/CreateMerchantInventories";
import MerchantInventoriesList from "views/MerchantInventories/MerchantInventoriesList";
import ViewMerchantInventories from "views/MerchantInventories/ViewMerchantInventories";

const merchantInventories = () => {
  let views = [];

  if (
    token["travelagent.inventories.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/MerchantInventories/List",
      name: "M Inventories",
      icon: ConfirmationNumberIcon,
      component: MerchantInventoriesList,
      layout: "/admin"
    });
  }

  return views;
};

const merchantInventoriesHidden = () => {
  let views = [];

  if (
    token["travelagent.inventories.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/MerchantInventories/Detail",
      name: "View Merchant Inventories",
      component: ViewMerchantInventories,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (
    token["travelagent.inventories.write"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/MerchantInventories/Create",
      name: "Create Merchant Inventories",
      component: CreateMerchantInventories,
      layout: "/admin"
    });
  }

  return [
    {
      collapse: true,
      name: "Merchant Inventories Hidden",
      state: "merchantInventoriesHidden",
      hideInSidebar: true,
      views
    }
  ];
};

export { merchantInventories, merchantInventoriesHidden };
